import { useEffect, useState } from 'react'

const isM = () => window.innerHeight <= 500 || window.innerWidth <= 500

export default function useMobile() {
    const [isMobile, setMobile] = useState(isM())
    useEffect(() => {
        function handleResize() {
            setMobile(isM())
        }
        window.addEventListener('resize', handleResize)
        handleResize()
        return () => window.removeEventListener('resize', handleResize)

    }, [])
    return isMobile
}
